import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Request from "common/Request";
import Modal from "common/Modal.jsx";
import { handleWarnings } from "./api";
import { safeStr, getPoliciesInRules } from "common/api";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import { ActionsRow } from "views/Status/Policies/Common";
import { Header } from "common/Header";
import Table from "common/graphs/Table/Table";
import { NumberCell } from "common/graphs/Table/TableRenders";

const doesNothing = () => {};

const returnView = "viewMonitoringPolicies";

const DeleteModalWrapper = styled.div`
  ul {
    padding: 0 0 0 15px;
    margin: -20px 0 20px 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;

    li {
      margin: 3px 0 !important;
    }
  }
`;

const FooterMessage = styled.div`
  color: red;
  ul {
    padding: 0 0 0 15px;
    margin: 0px 0 20px 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;

    li {
      margin: 3px 0 !important;
      text-align: left;
    }
  }
`;

const DeleteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  names = [],
  whenDone,
  rules = [],
}) => {
  const { delete: itemsToDelete, notDelete } = names.reduce(
    (acc, name) => {
      if (rules.includes(name)) {
        acc.notDelete.push(name);
      } else {
        acc.delete.push(name);
      }
      return acc;
    },
    { delete: [], notDelete: [] }
  );

  const handleApply = () => {
    const cmds = itemsToDelete.map((name) => `clear policy monitor ${safeStr(name)}`);
    ifCl
      .run(`${cmds.join("\n")}\n`, /*is batch*/ true)
      .then(handleWarnings)
      .then(() => {
        setShowDeleteModal(false);
        whenDone();
      })
      .catch((error) => showModalError(error, ""));
  };
  if (!showDeleteModal) {
    return null;
  }
  const title =
    itemsToDelete.length === 1
      ? `Remove "${itemsToDelete[0]}" policy?`
      : `Remove ${itemsToDelete.length} policies?`;
  return (
    <Modal
      title={title}
      onClose={() => setShowDeleteModal(false)}
      closeLabel="CANCEL"
      superIcon={"delete_forever"}
      large={names.length > 1 && names.length < 100}
      content={() => (
        <DeleteModalWrapper>
          {itemsToDelete.length === 1 ? (
            <p>
              WARNING: All policy data will be lost and all subscribers assigned
              to this policy will be reassigned to a default monitoring policy
              following the BQN configured rules (normally default policy is
              "monitor-default").
            </p>
          ) : null}
          {itemsToDelete.length > 1 ? (
            <>
              {itemsToDelete.length < 100 ? (
                <ul>
                  {itemsToDelete.map((name) => (
                    <li key={name}>{name}</li>
                  ))}
                </ul>
              ) : null}
              <p>
                WARNING: All policies data will be lost and all subscribers
                assigned to these policies will be reassigned to a default
                monitoring policy following the BQN configured rules (normally
                default policy is "monitor-default").
              </p>
            </>
          ) : null}
        </DeleteModalWrapper>
      )}
      applyLabel="YES"
      footerMessage={
        notDelete.length > 0 ? (
          <FooterMessage>
            <p>These policies cannot be deleted, because they are part of a rule.</p>
            <ul>
              {notDelete.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </FooterMessage>
        ) : null
      }
      onApply={handleApply}
    />
  );
};

const HelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="MONITORING POLICIES"
      onClose={doClose}
      content={() => (
        <>
          <p>
            Subscriber monitoring policies. Define actions to take on a
            subscriber basis. Subscribers are identified as a unique access-side
            IP address.{" "}
          </p>
          <ul>
            <li>
              <b>ACTIVE-SUBSCRIBERS</b>: Number of active subscribers.
            </li>
            <li>
              <b>MBYTES-DOWNLINK</b>: Traffic in the downlink direction.
            </li>
            <li>
              <b>MBYTES-UPLINK</b>: Traffic in the uplink direction.
            </li>
            <li>
              <b>UDR-GENERATION-%</b>: Percentage of monitorings generating UDR
              (Usage Data Record). Used by DPI reporting.
            </li>
            <li>
              <b>ACTIONS</b>: Allowed operations on this policy.
            </li>
          </ul>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i>{" "}
            icon to delete an already configured policy.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">refresh</i>{" "}
            icon to refresh policies information.
          </p>
        </>
      )}
    />
  );
};

function onAddPolicy() {
  globalNavigate("viewPolicyMonitorEdit", {
    returnView: "viewMonitoringPolicies",
  });
}
const ContextMenu = ({ doLoad = doesNothing }) => {
  const actions = useContext(ActionsContext);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li>
        <a
          data-loading-effect="pulse"
          data-toggle="cardloading"
          title="Help"
          onClick={() => actions.send("open-help")}
        >
          <i className="material-icons">help_outline</i>
        </a>
        <a
          onClick={() => doLoad(mode, bqnId)}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
      <li className="dropdown hidden-to-operators">
        <a
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          title="Options"
        >
          <i className="material-icons">more_vert</i>
        </a>
        <ul className="dropdown-menu pull-right">
          <li>
            <a onClick={onAddPolicy}>Add Policy...</a>
          </li>
        </ul>
      </li>
    </ul>
  );
};

export const PoliciesList = () => {
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const [request, setRequest] = useState(null);

  const doRequest = (mode, bqnId) => {
    const cliBqnSpec =
      mode === "standalone" || bqnId === "all" ? "" : ` bqn-id ${bqnId}`;
    return ifCl
      .run(
        `${[
          `show policy monitor statistics web${cliBqnSpec}`,
          "show config running all",
        ].join("\n")}\n`,
        /*is batch*/ true,
      )
      .then((response) => {
        const [policiesResponse, configResponse] = response.split(",");
        const rules = getPoliciesInRules(configResponse, "monitor");
        return { response: policiesResponse, rules };
      })
      .catch((error) => console.log(error));
  };

  const doLoad = (mode, bqnId) => {
    setRequest(doRequest(mode, bqnId));
  };

  useEffect(() => doLoad(mode, bqnId), [mode, bqnId]);

  if (request === null) {
    return null;
  }

  return (
    <div className="row clearfix">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div className="card">
          <Header
            title="Monitoring Policies"
            contextMenu={<ContextMenu doLoad={doLoad} />}
          />
          <div className="body table-responsive">
            <ActionsRow doCreatePolicy={onAddPolicy} />
            <Request during={request}>
              {(result) => (
                <ShowPolicies
                  {...result}
                  reload={() => doLoad(mode, bqnId)}
                  returnView={returnView}
                />
              )}
            </Request>
          </div>
        </div>
      </div>
    </div>
  );
};

const notFoundRE = /%ERR-ENOENT: Cannot find "(.*)" policy/;

/*****************************************************
 * Policies Table
 * ****************************************************/

const TableContainer = styled.div`
  width: 100%;
  overflow: auto;
`;

const openThroughputPerPolicy = (
  policyType = "monitor",
  directions = "downSpeed",
) => {
  globalNavigate("viewThroughputPerPolicy", {
    policyType,
    directions,
    returnView,
  });
};

const getColumns = ({
  reload,
  returnView,
  setDeleteSelected,
  setShowDeleteModal,
}) => {
  return [
    {
      label: "NAME",
      id: "NAME",
      numeric: false,
      cellClassName: "hyperlink-text",
      onClick: (value) => doEditPolicy(value, returnView),
    },
    {
      label: "ACTIVE-SUBSCRIBERS",
      id: "SUBSCRIBERS",
      numeric: true,
      renderCell: (value) => (
        <NumberCell value={value} precision={0} hasNA={true} />
      ),
    },
    {
      label: "MBYTES-DOWNLINK",
      id: "MBYTES-DOWNLINK",
      numeric: true,
      cellClassName: "hyperlink-text",
      renderCell: (value) => (
        <NumberCell value={value} precision={3} hasNA={true} />
      ),
      onClick: () => {
        openThroughputPerPolicy("monitor", "downSpeed");
      },
    },
    {
      label: "MBYTES-UPLINK",
      id: "MBYTES-UPLINK",
      numeric: true,
      cellClassName: "hyperlink-text",
      renderCell: (value) => (
        <NumberCell value={value} precision={3} hasNA={true} />
      ),
      onClick: () => {
        openThroughputPerPolicy("monitor", "upSpeed");
      },
    },
    {
      label: "UDR-GENERATION-%",
      id: "UDR",
      numeric: true,
    },
    {
      label: "ACTIONS",
      id: "ACTIONS",
      actions: [
        {
          label: "Edit",
          icon: "edit",
          onClick: (value) => {
            doEditPolicy(value["NAME"], returnView);
          },
        },
        {
          label: "Delete",
          icon: "delete",
          onClick: (value) => {
            setDeleteSelected([value["NAME"]]);
            setShowDeleteModal(true);
          },
          hide: (value) => value["NAME"] === "monitor-default",
        },
      ],
    },
  ];
};

export const ShowPolicies = ({
  response,
  rules = [],
  reload = doesNothing,
  returnView,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSelected, setDeleteSelected] = useState([]);
  const [header, ...rows] = response.trim(/\s/).split("\n");
  const headerAttrs = header.trim(/\s/).split(/\s+/);
  const [selected, setSelected] = useState([]);
  const attrIndexMap = headerAttrs.reduce((acc, attr, index) => {
    acc[attr] = index;
    return acc;
  }, {});
  const newRows = rows.map((row, index) => {
    const rowAttrs = row.trim(/\s/).split(/\s+/);
    const newEntry = rowAttrs.reduce(
      (acc, attr, index) => {
        acc[headerAttrs[index]] = attr;
        return acc;
      },
      { id: index },
    );
    return newEntry;
  });

  return (
    <>
      <TableContainer>
        <Table
          isSelectable={true}
          isRowSelectable={false}
          data={newRows}
          sort={true}
          columns={getColumns({
            reload,
            returnView,
            setDeleteSelected,
            setShowDeleteModal,
          })}
          search={true}
          csvPrefix="monitoring-policies"
          rowsPerPageNr={10}
          selected={selected}
          setSelected={(value) => {
            setSelected(value);
          }}
          deleteSelected={(values) => {
            const selectedNames = newRows
              .filter((row) => values.includes(row.id))
              .map((row) => row["NAME"]);
            setDeleteSelected(selectedNames);
            setShowDeleteModal(true);
          }}
        />
      </TableContainer>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        names={deleteSelected}
        whenDone={() => {
          setSelected([]);
          reload();
        }}
        rules={rules}
      />
      <HelpModal />
    </>
  );
};

const doEditPolicy = (policy, returnView) => {
  globalNavigate("viewPolicyMonitorEdit", {
    returnView,
    tab: 2,
    policy,
  });
};
